// File: scrollIntoViewIfNeeded.js

/**
 * Ensures a given element (via ref) is fully in view within a specified container (via ID),
 * using IntersectionObserver for efficient observation.
 * @param {React.RefObject} elementRef - The ref of the element to scroll into view.
 * @param {string} [containerId] - The ID of the container element (optional).
 */
const scrollIntoViewIfNeeded = (elementRef, containerId) => {
  if (!elementRef?.current) {
    console.warn("Invalid element ref provided.")
    return
  }

  const container = containerId ? document.getElementById(containerId) : null

  const observerCallback = (entries, observer) => {
    if (!elementRef?.current) {
      // Optionally disconnect after scrolling
      observer.disconnect()
    }
    const [entry] = entries

    if (!entry.isIntersecting) {
      // Scroll the element into view if not intersecting
      elementRef?.current?.scrollIntoView({
        behavior: "auto", // Instant scroll
        block: "center",
        inline: "nearest",
      })

      // Optionally disconnect after scrolling
      observer.disconnect()
    }
  }

  const observerOptions = {
    root: container || null, // Observe within the container or viewport
    threshold: 1.0, // Fully visible
  }

  const observer = new IntersectionObserver(observerCallback, observerOptions)

  // Start observing the element
  observer.observe(elementRef.current)

  return () => {
    // Cleanup observer manually if needed
    observer.disconnect()
  }
}

export default scrollIntoViewIfNeeded
